import React from "react";

export default function TableWrapper({
  title,
  children,
  titleColor = "text-gray-400",
}) {
  return (
    <div className="bg-gray-900/90 rounded-lg shadow-lg p-4 border border-gray-800">
      {title && (
        <h4 className="font-medium mb-3 text-sm text-gray-300">{title}</h4>
      )}
      <div className="overflow-x-auto">
        <div className="min-w-full">{children}</div>
      </div>
    </div>
  );
}
